import * as React from 'react'
import { InputAttributes, NumberFormatValues, NumericFormat, NumericFormatProps } from 'react-number-format'

import Input from './Input'
import { StyledContainerPhoneSSNCurrency, StyledLabel, StyledTopContainer } from './styles/InputStyles'

type CustomProps = {
	label?: React.ReactNode
	onChange: (event: { target: { name: string; value: string } }) => void
	inputRef?(ref: React.RefObject<HTMLInputElement>): void
	name: string
	value?: string | number
	onBlur?: () => void
	error?: boolean
	style?: React.CSSProperties
	helperText?: string
	id?: string
	width: string
	maxLength?: number
	placeholder?: string
	autoFocus?: boolean
	getIsAllowedValue: (values: NumberFormatValues) => boolean
	decimalScale?: number
	suffix?: string
	min?: number
	max?: number
	className?: string
	testId?: string
	allowNegative?: boolean
}

type UnknownObject = { [key: string]: any }

type Props = NumericFormatProps<InputAttributes> & CustomProps

const NumberFormatCurrencyInput = React.forwardRef(
	(
		{
			label,
			onChange,
			name,
			value,
			onBlur,
			error,
			style,
			helperText,
			id = 'amount-input',
			width,
			maxLength,
			placeholder,
			autoFocus,
			getIsAllowedValue,
			decimalScale,
			suffix,
			min,
			max,
			className,
			testId,
			allowNegative = false,
			...other
		}: Props,
		ref: React.Ref<HTMLInputElement>
	) => {
		return (
			<StyledContainerPhoneSSNCurrency width={width} className={className}>
				<NumericFormat
					{...other}
					style={style}
					id={id}
					customInput={Input}
					getInputRef={ref}
					onValueChange={(values: UnknownObject) => {
						onChange({
							target: {
								name,
								value: values.value,
							},
						})
					}}
					decimalScale={decimalScale ?? 0}
					value={value}
					min={min}
					max={max}
					autoFocus={autoFocus}
					onBlur={onBlur}
					thousandSeparator='.'
					decimalSeparator=','
					valueIsNumericString
					suffix={suffix ?? ' kr.'}
					type='tel'
					allowNegative={allowNegative}
					width={width}
					{...(error && helperText && { errorText: helperText })}
					maxLength={maxLength}
					placeholder={placeholder}
					isAllowed={getIsAllowedValue}
				/>{' '}
				{label === undefined ? null : (
					<StyledTopContainer>
						{label && (
							<StyledLabel data-testid={`${testId}-label`} htmlFor={id}>
								{label}
							</StyledLabel>
						)}
					</StyledTopContainer>
				)}
			</StyledContainerPhoneSSNCurrency>
		)
	}
)

NumberFormatCurrencyInput.displayName = 'NumberFormatCurrencyInput'

export default NumberFormatCurrencyInput
